import React from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './ComplianceInfoModal.css'; // We'll create this CSS file

const ComplianceInfoModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered size="lg" className="compliance-info-modal">
      <Modal.Header closeButton>
        <Modal.Title as="h5">Compliance & Quick Links</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Quick Links Section */}
        <div className="compliance-section mb-4">
          <h6 className="compliance-section-title mb-3">Quick Links:</h6>
          <Row className="footer-quick-links"> {/* Reusing class from Footer for potential style reuse */}
            <Col xs={12} sm={6} md={3} className="mb-2">
              <Link to="/legal#terms-and-conditions" className="footer-link" onClick={handleClose}>
                Terms &amp; Conditions
              </Link>
            </Col>
            <Col xs={12} sm={6} md={3} className="mb-2">
              <Link to="/legal#privacy-policy" className="footer-link" onClick={handleClose}>
                Privacy Policy
              </Link>
            </Col>
            <Col xs={12} sm={6} md={3} className="mb-2">
              <Link to="/legal#investor-charter" className="footer-link" onClick={handleClose}>
                Investor Charter
              </Link>
            </Col>
            <Col xs={12} sm={6} md={3} className="mb-2">
              <Link to="/legal#complaints-data" className="footer-link" onClick={handleClose}>
                Complaints Data
              </Link>
            </Col>
          </Row>
        </div>

        {/* Divider */}
        <hr className="compliance-divider my-4" />

        {/* Regulatory & Compliance Section */}
        <div className="compliance-section">
          <h6 className="compliance-section-title mb-3">Regulatory & Compliance:</h6>
          <div className="footer-compliance-text mb-3"> {/* Reusing class */}
            SCORES: Clients may submit grievances directly to SEBI on the{' '}
            <a href="https://scores.sebi.gov.in" target="_blank" rel="noopener noreferrer" className="footer-link-bold">SEBI SCORES portal</a>
            {' '} | Get the SEBI SCORES mobile app →{' '}
            <a href="https://play.google.com/store/apps/details?id=com.sebi" target="_blank" rel="noopener noreferrer" className="footer-link-bold">Android</a>
            {' '}/{' '}
            <a href="https://apps.apple.com/us/app/sebiscores/id6478849917" target="_blank" rel="noopener noreferrer" className="footer-link-bold">iOS</a>
          </div>
          <div className="footer-compliance-text"> {/* Reusing class */}
            ODR: Online Dispute Resolution Mechanism, as per SEBI regulations, is accessible on the{' '}
            <a href="https://smartodr.in/intermediary-register" target="_blank" rel="noopener noreferrer" className="footer-link-bold">Smart ODR portal</a>
            {' '} | BSE Enlistment No:{' '}
            <span className="enlist-no">6434</span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={handleClose}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ComplianceInfoModal; 